import { render, staticRenderFns } from "./SiloListCompactData.vue?vue&type=template&id=4ce18d8c"
import script from "./SiloListCompactData.vue?vue&type=script&lang=js"
export * from "./SiloListCompactData.vue?vue&type=script&lang=js"
import style0 from "./SiloListCompactData.vue?vue&type=style&index=0&id=4ce18d8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports